module.exports = __webpack_public_path__ + "img/about-leaf.4beabc82.png";